import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import logo from "../img/logo.jpeg";
import backgroundImage from "../img/bottom.png"; // Your background image
import border from "../img/border.jpeg";
import send from "../img/send.png";
import axios from "axios";
import { FaLinkedin, FaSpinner } from "react-icons/fa6";

export default function Footer() {

  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSendEmail = async () => {
    if (isLoading) return;

    if (!isValidEmail(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    setIsLoading(true);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/send-email`, {
        sender: 'edu@angelwatch.org',
        to: ['edu@angelwatch.org'],
        subject: `New user email submitted from ${email}`,
        html_body: `<p>You got a new customer. Email address is <strong>${email}</strong>.</p>`
      });

      setSuccessMessage("Thank you! We will get back to you asap!");
      setIsLoading(false);
      setEmail("");
    } catch (err) {
      setErrorMessage(err.response?.data || err.message);
      setIsLoading(false);
    }
  }

  const handleChangeEmail = (value) => {
    setEmail(value);
    setErrorMessage("");
    setSuccessMessage("");
  }

  return (
    <footer className="bg-[#F0AA00]  text-white">
      {/* Top Contact Strip */}
      <div className="bg-yellow-500 text-white px-4 py-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between text-left">
          {/* Phone */}
          <div className="flex items-start md:items-center px-4 py-2 w-full md:w-auto">
            <div className="bg-white rounded-full p-2 mr-2">
              <FaPhoneAlt className="text-yellow-500 h-5 w-5" />
            </div>
            <a href="tel:+18003816794">
              <span className="text-base sm:text-lg font-medium whitespace-nowrap text-white hover:text-blue-600 transition-colors">
                +1 800-381-6794
              </span>
            </a>
          </div>

          {/* Email */}
          <div className="flex items-start md:items-center px-4 py-2 w-full md:w-auto">
            <div className="bg-white rounded-full p-2 mr-2">
              <FaEnvelope className="text-yellow-500 h-5 w-5" />
            </div>
            <a
              href="mailto:Edu@AngelWatch.org"
              className="text-base sm:text-lg font-medium whitespace-nowrap text-white hover:underline"
            >
              Edu@AngelWatch.org
            </a>
          </div>

          {/* Address */}
          <div className="flex items-start md:items-center px-4 py-2 w-full md:w-auto">
            <div className="bg-white rounded-full p-2 mr-2">
              <FaMapMarkerAlt className="text-yellow-500 h-5 w-5" />
            </div>
            <div className="text-base sm:text-lg font-medium leading-tight">
              <span className="block">Hampton Reserve Drive,</span>
              <span className="block">Brentwood Tennessee, 37027</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer with Background Image */}
      <div
        className="text-white py-10 px-6 md:px-16 bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundColor: "#2E2151", // Fallback color
        }}
      >
        <div className="max-w-7xl mx-auto">
          <div>
            <div className="grid grid-cols-1  lg:grid-cols-4 gap-10">
              {/* Logo and Disclaimer */}
              <div className="space-y-4">
                <a href="/">
                  <img className="h-[81px] w-[88px] mb-4" src={logo} alt="logo" />
                </a>
                <p
                  style={{ fontFamily: "poppins" }}
                  className="text-[17px] leading-relaxed"
                >
                  All of our techniques, trainings, equipment, software, hardware, and instructional materials are classified and
                  proprietary to the AngelWatch Foundation. We do not publicly disclose our teaching methodologies. This confidentiality is essential to ensure the ongoing safety of our Children, Teachers, Schools, and Daycares throughout the United States.
                </p>
              </div>

              {/* Quick Links */}
              <div>
                <h3
                  style={{ fontFamily: "poppins" }}
                  className="lg:text-[26px] text-[18px]  mb-2 font-semibold w-fit"
                >
                  Quick Links
                </h3>
                <img className="w-[130px] mb-4" src={border} />
                <ul
                  style={{ fontFamily: "poppins" }}
                  className="lg:space-y-6 space-y-2 lg:text-[19px] text-[15px]"
                >
                  <li>
                    <a href="/">» Home</a>
                  </li>
                  <li>
                    <a href="/about">» About Us</a>
                  </li>
                  <li>
                    <a href="">» Contact Us</a>
                  </li>
                  <li>
                    <a href="/faq">» FAQs</a>
                  </li>
                  <li>
                    <a href={`${process.env.REACT_APP_ADMIN_URL}/login`}>
                      » Login / Register
                    </a>
                  </li>
                </ul>
              </div>

              {/* Useful Link */}
              <div>
                <h3
                  style={{ fontFamily: "poppins" }}
                  className="lg:text-[26px] text-[18px] mb-2 font-semibold w-fit"
                >
                  Useful Links
                </h3>
                <img className="w-[130px] mb-4" src={border} />
                <ul
                  style={{ fontFamily: "poppins" }}
                  className="lg:space-y-6 space-y-2 lg:text-[19px] text-[15px]"
                >
                  <li>
                    <a href="/include">» Included</a>
                  </li>
                  <li>
                    <a href="/CareGiver">» CareGiver</a>
                  </li>
                  <li>
                    <a href="/getCertified">» Get Certified</a>
                  </li>
                  <li>
                    <a href="/howItWork">» How It Works</a>
                  </li>
                </ul>
              </div>

              {/* Newsletter */}
              <div>
                <h3
                  style={{ fontFamily: "poppins" }}
                  className="lg:text-[26px] text-[18px] mb-2 font-semibold"
                >
                  Newsletter
                </h3>
                <img className="w-[130px] mb-4" src={border} />

                <p
                  style={{ fontFamily: "poppins" }}
                  className="lg:text-[19px] text-[15px] mb-4"
                >
                  For more information contact us
                </p>
                <div className="flex items-center border border-gray-300 rounded-full overflow-hidden">
                  <input
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => handleChangeEmail(e.target.value)}
                    className="w-full px-2 h-[45px] text-[16px] border-[#ccc] bg-[#241442E8] text-white placeholder-white focus:outline-none"
                  />
                  <img onClick={handleSendEmail} className=" w-[41px] mr-1" src={send} alt="send icon" />
                </div>
                {successMessage ? (<p className="text-lg text-green-600 mt-1">{successMessage}</p>) : <></>}
                {errorMessage ? (<p className="text-lg text-red-600 mt-1">{errorMessage}</p>) : <></>}

                <div className="flex mt-6 items-center space-x-4 mt-2">
                  <span>Follow Us On</span>
                  <a
                    href="https://www.facebook.com/AngelWatchAccreditation"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="cursor-pointer hover:text-yellow-400" />
                  </a>

                  <a
                    href="https://www.instagram.com/angelwatchusa/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram className="cursor-pointer hover:text-yellow-400" />
                  </a>

                  <a
                    href="https://www.youtube.com/@angelwatchfoundation2022"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaYoutube className="cursor-pointer hover:text-yellow-400" />
                  </a>

                  <a
                    href="https://www.linkedin.com/company/angelwatch-national-accreditation-program/?viewAsMember=true"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin className="cursor-pointer hover:text-yellow-400" />
                  </a>
                </div>
              </div>
            </div>

            {/* Footer Bottom */}
            <div className="border-t border-white mt-10 pt-4 flex flex-col md:flex-row justify-between text-[16px] text-center md:text-left space-y-2 md:space-y-0">
              <p>© 2025 AngelWatch LMS. All rights reserved.</p>
              <div className="space-x-4 text-[15px]">
                <a href="/terms" className="hover:underline">
                  Terms & Conditions
                </a>
                <a href="/privacy" className="hover:underline">
                  Privacy Policy
                </a>
                <a href="/unsubscribe" className="hover:underline">
                  Unsubscribe
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
